define('views/pages/checkout/CheckoutStepView',['underscore','backbone','SubView'],
    function (_,Backbone,SubView) {

        var CheckoutStepView =  Backbone.View.extend(SubView).extend({
            name:'default',
            className:'checkout-opc__step',
            initialize:function(){
                var view = this;
                view.subviews = [];
                Backbone.View.prototype.initialize.apply(view,arguments);
            },
            init:function(checkoutModel){
                var view = this;
                view.beforeInitialize(checkoutModel);
                view.render();
            },
            beforeInitialize:function(checkoutModel){},
            afterInitialize:function(checkoutModel){},
            render:function(){
                var view = this;
                view.$el.text(view.name);
            }
        });

        return CheckoutStepView;

    });
